import Factory from './Factory';

export {
  Factory
}



// WEBPACK FOOTER //
// ./src/components/admin/Help/Missions/AcceptDialogs/index.js